export const iconFontAwesomeTravelHotelCarSide = (
	<i className="fa-solid fa-car-side"></i>
);
